var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("wrapper", [
    _vm.partner
      ? _c(
          "section",
          { staticClass: "challenge-partner-page" },
          [
            _vm.modal.isVisible("deletePartner")
              ? _c(
                  "modal",
                  {
                    attrs: {
                      title: "Delete " + _vm.partner.name,
                      "show-footer": false
                    },
                    on: {
                      close: function($event) {
                        return _vm.modal.hide("deletePartner")
                      }
                    }
                  },
                  [
                    _c("p", { staticClass: "text-danger lead" }, [
                      _vm._v("This partner will be permanently deleted.")
                    ]),
                    _vm.hasLinks
                      ? _c("p", { staticClass: "text-warning" }, [
                          _c("i", { staticClass: "fa fa-warning" }),
                          _vm._v(
                            " This partner has links and cannot be deleted. Remove all links first. "
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.modal.hide("deletePartner")
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        ),
                        _c(
                          "loading-button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: {
                              type: "button",
                              disabled: _vm.hasLinks,
                              isLoading: _vm.isDeleting
                            },
                            on: { click: _vm.deletePartner }
                          },
                          [_vm._v("Delete Permanently")]
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-7" }, [
                _vm.partner.link_counts
                  ? _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c(
                              "flip-card",
                              [
                                _c("dash-box", {
                                  attrs: {
                                    slot: "front",
                                    title: "Schools Linked",
                                    value:
                                      _vm.partner.link_counts.organisations,
                                    active_value:
                                      _vm.partner.link_counts
                                        .organisations_referred,
                                    active_icon: "\\F0C1"
                                  },
                                  slot: "front"
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dashbox__help",
                                    attrs: { slot: "back" },
                                    slot: "back"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.partner.link_counts.organisations
                                        )
                                      )
                                    ]),
                                    _vm._v(
                                      " schools are linked with this partner, "
                                    ),
                                    _c("i", { staticClass: "fa fa-link" }),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.partner.link_counts
                                            .organisations_referred
                                        )
                                      )
                                    ]),
                                    _vm._v(" of those were referred.")
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c(
                              "flip-card",
                              [
                                _c("dash-box", {
                                  attrs: {
                                    slot: "front",
                                    title: "Parents Linked",
                                    value: _vm.partner.link_counts.users,
                                    active_value:
                                      _vm.partner.link_counts.users_referred,
                                    active_icon: "\\F0C1"
                                  },
                                  slot: "front"
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dashbox__help",
                                    attrs: { slot: "back" },
                                    slot: "back"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.partner.link_counts.users)
                                      )
                                    ]),
                                    _vm._v(
                                      " parents are linked with this partner, "
                                    ),
                                    _c("i", { staticClass: "fa fa-link" }),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.partner.link_counts.users_referred
                                        )
                                      )
                                    ]),
                                    _vm._v(" of those were referred.")
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "col-md-5" }, [
                _c(
                  "div",
                  { staticClass: "flex justify-content-end column-gap-3 mb-4" },
                  [
                    !_vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.startEditing }
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                    _vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function($event) {
                                _vm.isEditing = false
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: {
                          disabled: _vm.hasLinks,
                          title: _vm.hasLinks
                            ? "Cannot delete a partner that has links"
                            : ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.modal.show("deletePartner")
                          }
                        }
                      },
                      [_vm._v("Delete")]
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-7" }, [
                _c("div", { staticClass: "box box-info" }, [
                  _c(
                    "div",
                    { staticClass: "box-body" },
                    [
                      !_vm.isEditing
                        ? _c("table", { staticClass: "table table-striped" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("th", [_vm._v("Slug")]),
                                _c("td", [_vm._v(_vm._s(_vm.partner.slug))])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Category")]),
                                _c("td", [_vm._v(_vm._s(_vm.partner.category))])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Links To")]),
                                _c("td", [_vm._v(_vm._s(_vm.linksToDisplay))])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Contact Email")]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.partner.contact_email || "—")
                                  )
                                ])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Website")]),
                                _c("td", [
                                  _vm.partner.website
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.partner.website,
                                            target: "_blank",
                                            rel: "noopener"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.partner.website))]
                                      )
                                    : _c("span", [_vm._v("—")])
                                ])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Logo")]),
                                _c("td", [
                                  _vm.partner.logo_url
                                    ? _c("div", [
                                        _c("img", {
                                          staticClass: "partner-logo",
                                          attrs: {
                                            src: _vm.partner.logo_url,
                                            alt: _vm.partner.name + " logo"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.partner.logo_filename)
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("span", [_vm._v("—")])
                                ])
                              ]),
                              _vm.partner.referral_url
                                ? _c("tr", [
                                    _c("th", [_vm._v("Referral URL")]),
                                    _c("td", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.partner.referral_url,
                                            target: "_blank",
                                            rel: "noopener"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.partner.referral_url)
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "referral-qrcode" },
                                        [
                                          _c("qrcode", {
                                            attrs: {
                                              value: _vm.partner.referral_url,
                                              options: { width: 160, margin: 1 }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e(),
                      _vm.isEditing
                        ? _c("challenge-partner-form", {
                            attrs: {
                              value: _vm.editForm,
                              "is-loading": _vm.isSaving,
                              "submit-label": "Save Changes"
                            },
                            on: { validated: _vm.handleUpdate }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "col-md-5" }, [
                !_vm.partner.parent_id
                  ? _c("div", { staticClass: "box box-info" }, [
                      _c(
                        "div",
                        { staticClass: "box-header with-border" },
                        [
                          _c("h3", { staticClass: "box-title" }, [
                            _vm._v("Branches")
                          ]),
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-xs btn-link pull-right",
                              attrs: {
                                to:
                                  "/challenges/" +
                                  _vm.challengeSlug +
                                  "/partners/new?parent=" +
                                  _vm.partner.slug
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-plus",
                                staticStyle: {
                                  "font-size": "0.9em",
                                  "margin-right": "3px"
                                }
                              }),
                              _vm._v("Create Branch ")
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.sortedChildren.length > 0
                        ? _c("div", { staticClass: "box-body" }, [
                            _c(
                              "ul",
                              { staticClass: "list-unstyled" },
                              _vm._l(_vm.sortedChildren, function(branch) {
                                return _c(
                                  "li",
                                  { key: branch.id, staticClass: "mb-2" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to:
                                            "/challenges/" +
                                            _vm.challengeSlug +
                                            "/partners/" +
                                            branch.slug
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-circle-o"
                                        }),
                                        _vm._v(" " + _vm._s(branch.name) + " ")
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ])
                        : _c("div", { staticClass: "box-body" }, [
                            _c("p", { staticClass: "text-muted" }, [
                              _vm._v("No branches yet")
                            ])
                          ])
                    ])
                  : _vm._e()
              ])
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }